export const GM_METHODS = {
    // Potwierdzenie rejestracji użytkownika
    CONFIRM_REGISTRATION: 'confirmRegistration',

    // Potwierdzenie zmiany adresu e-mail
    CONFIRM_EMAIL_CHANGE: 'confirmEmailChange',

    // Ustawienie nowego hasła dla konta użytkownika
    RESET_PASSWORD: 'resetPassword',
};
